import React from 'react';

export function QuizSkeleton() {
  return (
    <div>
      <div className="flex flex-col space-y-2 p-3 ">
        <div className="h-14 w-full animate-pulse  bg-gray-300"></div>
      </div>
      <div className="w-full gap-4 items-start">
        <div className="flex flex-col gap-2 p-3">
          {React.Children.toArray(
            Array.from({ length: 5 }, (_, i) => i + 1).map(() => {
              return (
                <div className="flex space-x-2">
                  <div className="h-10 w-10 animate-pulse rounded-sm bg-gray-300"></div>
                  <div className="h-10 w-full animate-pulse rounded-sm bg-gray-300"></div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
